import React from 'react';
import namrata from '../../../assets/client logos/namrata.svg';
import jugni from '../../../assets/client logos/jugniandcc.svg';
import digitaltokari from '../../../assets/client logos/digitaltokri.svg';
import theclub from '../../../assets/client logos/theclub.svg';
import palate from '../../../assets/client logos/palate.svg';
import mpl from '../../../assets/client logos/mpl.svg';
import nifd from '../../../assets/client logos/nifd.svg';
import setuequal from '../../../assets/client logos/setuequal.svg';
import data from '../../../assets/client logos/data.svg';
import ranka from '../../../assets/client logos/ranka.svg';
import federalbank from '../../../assets/client logos/federalbank.svg';
import socks from '../../../assets/client logos/socks.svg';
import chique from '../../../assets/client logos/chique.svg';
import puraniks from '../../../assets/client logos/puraniks.svg';
import aromas from '../../../assets/client logos/aromas.svg';
import mandke from '../../../assets/client logos/mandke.svg';
import square from '../../../assets/client logos/square.svg';
import "../../../css/client-logo.css";

function ClientLogoSection() {

    return (
        <div class="client-logo-container">
            <div class="logos">
                <div class="logos-slide-reverse">
                    <img className='h-20 xl:h-24' src={data} alt="logo1" class="logo" />
                    <img className='h-20 xl:h-24' src={ranka} alt="logo2" class="logo" />
                    <img className='h-20 xl:h-24' src={federalbank} alt="logo3" class="logo" />
                    <img className='h-20 xl:h-24' src={socks} alt="logo4" class="logo" />
                    <img className='h-20 xl:h-24' src={chique} alt="logo5" class="logo" />
                    <img className='h-20 xl:h-24' src={puraniks} alt="logo6" class="logo" />
                    <img className='h-20 xl:h-24' src={aromas} alt="logo7" class="logo" />
                    <img className='h-20 xl:h-24' src={mandke} alt="logo8" class="logo" />
                    <img className='h-20 xl:h-24' src={square} alt="logo9" class="logo" />
                    <img className='h-20 xl:h-24' src={data} alt="logo1" class="logo" />
                    <img className='h-20 xl:h-24' src={ranka} alt="logo2" class="logo" />
                    <img className='h-20 xl:h-24' src={federalbank} alt="logo3" class="logo" />
                    <img className='h-20 xl:h-24' src={socks} alt="logo4" class="logo" />
                    <img className='h-20 xl:h-24' src={chique} alt="logo5" class="logo" />
                    <img className='h-20 xl:h-24' src={puraniks} alt="logo6" class="logo" />
                    <img className='h-20 xl:h-24' src={aromas} alt="logo7" class="logo" />
                    <img className='h-20 xl:h-24' src={mandke} alt="logo8" class="logo" />
                    <img className='h-20 xl:h-24' src={square} alt="logo9" class="logo" />
                    <img className='h-20 xl:h-24' src={data} alt="logo1" class="logo" />
                    <img className='h-20 xl:h-24' src={ranka} alt="logo2" class="logo" />
                    <img className='h-20 xl:h-24' src={federalbank} alt="logo3" class="logo" />
                    <img className='h-20 xl:h-24' src={socks} alt="logo4" class="logo" />
                    <img className='h-20 xl:h-24' src={chique} alt="logo5" class="logo" />
                    <img className='h-20 xl:h-24' src={puraniks} alt="logo6" class="logo" />
                    <img className='h-20 xl:h-24' src={aromas} alt="logo7" class="logo" />
                    <img className='h-20 xl:h-24' src={mandke} alt="logo8" class="logo" />
                    <img className='h-20 xl:h-24' src={square} alt="logo9" class="logo" />
                    <img className='h-20 xl:h-24' src={data} alt="logo1" class="logo" />
                    <img className='h-20 xl:h-24' src={ranka} alt="logo2" class="logo" />
                    <img className='h-20 xl:h-24' src={federalbank} alt="logo3" class="logo" />
                    <img className='h-20 xl:h-24' src={socks} alt="logo4" class="logo" />
                    <img className='h-20 xl:h-24' src={chique} alt="logo5" class="logo" />
                    <img className='h-20 xl:h-24' src={puraniks} alt="logo6" class="logo" />
                    <img className='h-20 xl:h-24' src={aromas} alt="logo7" class="logo" />
                    <img className='h-20 xl:h-24' src={mandke} alt="logo8" class="logo" />
                    <img className='h-20 xl:h-24' src={square} alt="logo9" class="logo" />
                </div>
                <div class="logos-slide-reverse">
                    <img className='h-20 xl:h-24' src={data} alt="logo1" class="logo" />
                    <img className='h-20 xl:h-24' src={ranka} alt="logo2" class="logo" />
                    <img className='h-20 xl:h-24' src={federalbank} alt="logo3" class="logo" />
                    <img className='h-20 xl:h-24' src={socks} alt="logo4" class="logo" />
                    <img className='h-20 xl:h-24' src={chique} alt="logo5" class="logo" />
                    <img className='h-20 xl:h-24' src={puraniks} alt="logo6" class="logo" />
                    <img className='h-20 xl:h-24' src={aromas} alt="logo7" class="logo" />
                    <img className='h-20 xl:h-24' src={mandke} alt="logo8" class="logo" />
                    <img className='h-20 xl:h-24' src={square} alt="logo9" class="logo" />
                    <img className='h-20 xl:h-24' src={data} alt="logo1" class="logo" />
                    <img className='h-20 xl:h-24' src={ranka} alt="logo2" class="logo" />
                    <img className='h-20 xl:h-24' src={federalbank} alt="logo3" class="logo" />
                    <img className='h-20 xl:h-24' src={socks} alt="logo4" class="logo" />
                    <img className='h-20 xl:h-24' src={chique} alt="logo5" class="logo" />
                    <img className='h-20 xl:h-24' src={puraniks} alt="logo6" class="logo" />
                    <img className='h-20 xl:h-24' src={aromas} alt="logo7" class="logo" />
                    <img className='h-20 xl:h-24' src={mandke} alt="logo8" class="logo" />
                    <img className='h-20 xl:h-24' src={square} alt="logo9" class="logo" />
                    <img className='h-20 xl:h-24' src={data} alt="logo1" class="logo" />
                    <img className='h-20 xl:h-24' src={ranka} alt="logo2" class="logo" />
                    <img className='h-20 xl:h-24' src={federalbank} alt="logo3" class="logo" />
                    <img className='h-20 xl:h-24' src={socks} alt="logo4" class="logo" />
                    <img className='h-20 xl:h-24' src={chique} alt="logo5" class="logo" />
                    <img className='h-20 xl:h-24' src={puraniks} alt="logo6" class="logo" />
                    <img className='h-20 xl:h-24' src={aromas} alt="logo7" class="logo" />
                    <img className='h-20 xl:h-24' src={mandke} alt="logo8" class="logo" />
                    <img className='h-20 xl:h-24' src={square} alt="logo9" class="logo" />
                    <img className='h-20 xl:h-24' src={data} alt="logo1" class="logo" />
                    <img className='h-20 xl:h-24' src={ranka} alt="logo2" class="logo" />
                    <img className='h-20 xl:h-24' src={federalbank} alt="logo3" class="logo" />
                    <img className='h-20 xl:h-24' src={socks} alt="logo4" class="logo" />
                    <img className='h-20 xl:h-24' src={chique} alt="logo5" class="logo" />
                    <img className='h-20 xl:h-24' src={puraniks} alt="logo6" class="logo" />
                    <img className='h-20 xl:h-24' src={aromas} alt="logo7" class="logo" />
                    <img className='h-20 xl:h-24' src={mandke} alt="logo8" class="logo" />
                    <img className='h-20 xl:h-24' src={square} alt="logo9" class="logo" />
                </div>

            </div>
            <div class="logos">
                <div class="logos-slide">
                    <img className="h-20 xl:h-24" src={namrata} alt="logo1" class="logo" />
                    <img className="h-20 xl:h-24" src={jugni} alt="logo2" class="logo" />
                    <img className="h-20 xl:h-24" src={digitaltokari} alt="logo3" class="logo" />
                    <img className="h-20 xl:h-24" src={theclub} alt="logo4" class="logo" />
                    <img className="h-20 xl:h-24" src={palate} alt="logo5" class="logo" />
                    <img className="h-20 xl:h-24" src={mpl} alt="logo6" class="logo" />
                    <img className="h-20 xl:h-24" src={nifd} alt="logo7" class="logo" />
                    <img className="h-20 xl:h-24" src={setuequal} alt="logo8" class="logo" />
                    <img className="h-20 xl:h-24" src={namrata} alt="logo1" class="logo" />
                    <img className="h-20 xl:h-24" src={jugni} alt="logo2" class="logo" />
                    <img className="h-20 xl:h-24" src={digitaltokari} alt="logo3" class="logo" />
                    <img className="h-20 xl:h-24" src={theclub} alt="logo4" class="logo" />
                    <img className="h-20 xl:h-24" src={palate} alt="logo5" class="logo" />
                    <img className="h-20 xl:h-24" src={mpl} alt="logo6" class="logo" />
                    <img className="h-20 xl:h-24" src={nifd} alt="logo7" class="logo" />
                    <img className="h-20 xl:h-24" src={setuequal} alt="logo8" class="logo" />
                    <img className="h-20 xl:h-24" src={namrata} alt="logo1" class="logo" />
                    <img className="h-20 xl:h-24" src={jugni} alt="logo2" class="logo" />
                    <img className="h-20 xl:h-24" src={digitaltokari} alt="logo3" class="logo" />
                    <img className="h-20 xl:h-24" src={theclub} alt="logo4" class="logo" />
                    <img className="h-20 xl:h-24" src={palate} alt="logo5" class="logo" />
                    <img className="h-20 xl:h-24" src={mpl} alt="logo6" class="logo" />
                    <img className="h-20 xl:h-24" src={nifd} alt="logo7" class="logo" />
                    <img className="h-20 xl:h-24" src={setuequal} alt="logo8" class="logo" />
                    <img className="h-20 xl:h-24" src={namrata} alt="logo1" class="logo" />
                    <img className="h-20 xl:h-24" src={jugni} alt="logo2" class="logo" />
                    <img className="h-20 xl:h-24" src={digitaltokari} alt="logo3" class="logo" />
                    <img className="h-20 xl:h-24" src={theclub} alt="logo4" class="logo" />
                    <img className="h-20 xl:h-24" src={palate} alt="logo5" class="logo" />
                    <img className="h-20 xl:h-24" src={mpl} alt="logo6" class="logo" />
                    <img className="h-20 xl:h-24" src={nifd} alt="logo7" class="logo" />
                    <img className="h-20 xl:h-24" src={setuequal} alt="logo8" class="logo" />
                </div>
                <div class="logos-slide">
                    <img className="h-20 xl:h-24" src={namrata} alt="logo1" class="logo" />
                    <img className="h-20 xl:h-24" src={jugni} alt="logo2" class="logo" />
                    <img className="h-20 xl:h-24" src={digitaltokari} alt="logo3" class="logo" />
                    <img className="h-20 xl:h-24" src={theclub} alt="logo4" class="logo" />
                    <img className="h-20 xl:h-24" src={palate} alt="logo5" class="logo" />
                    <img className="h-20 xl:h-24" src={mpl} alt="logo6" class="logo" />
                    <img className="h-20 xl:h-24" src={nifd} alt="logo2" class="logo" />
                    <img className="h-20 xl:h-24" src={setuequal} alt="logo3" class="logo" />
                    <img className="h-20 xl:h-24" src={namrata} alt="logo1" class="logo" />
                    <img className="h-20 xl:h-24" src={jugni} alt="logo2" class="logo" />
                    <img className="h-20 xl:h-24" src={digitaltokari} alt="logo3" class="logo" />
                    <img className="h-20 xl:h-24" src={theclub} alt="logo4" class="logo" />
                    <img className="h-20 xl:h-24" src={palate} alt="logo5" class="logo" />
                    <img className="h-20 xl:h-24" src={mpl} alt="logo6" class="logo" />
                    <img className="h-20 xl:h-24" src={nifd} alt="logo7" class="logo" />
                    <img className="h-20 xl:h-24" src={setuequal} alt="logo8" class="logo" />
                    <img className="h-20 xl:h-24" src={namrata} alt="logo1" class="logo" />
                    <img className="h-20 xl:h-24" src={jugni} alt="logo2" class="logo" />
                    <img className="h-20 xl:h-24" src={digitaltokari} alt="logo3" class="logo" />
                    <img className="h-20 xl:h-24" src={theclub} alt="logo4" class="logo" />
                    <img className="h-20 xl:h-24" src={palate} alt="logo5" class="logo" />
                    <img className="h-20 xl:h-24" src={mpl} alt="logo6" class="logo" />
                    <img className="h-20 xl:h-24" src={nifd} alt="logo7" class="logo" />
                    <img className="h-20 xl:h-24" src={setuequal} alt="logo8" class="logo" />
                    <img className="h-20 xl:h-24" src={namrata} alt="logo1" class="logo" />
                    <img className="h-20 xl:h-24" src={jugni} alt="logo2" class="logo" />
                    <img className="h-20 xl:h-24" src={digitaltokari} alt="logo3" class="logo" />
                    <img className="h-20 xl:h-24" src={theclub} alt="logo4" class="logo" />
                    <img className="h-20 xl:h-24" src={palate} alt="logo5" class="logo" />
                    <img className="h-20 xl:h-24" src={mpl} alt="logo6" class="logo" />
                    <img className="h-20 xl:h-24" src={nifd} alt="logo7" class="logo" />
                    <img className="h-20 xl:h-24" src={setuequal} alt="logo8" class="logo" />
                </div>
            </div>

        </div>
    )
}

export default ClientLogoSection;
